"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var idb_1 = require("idb");
// function get_date_string(d){
//     // keep only minutes
//     return d.toLocaleString().split(':').slice(0,2).join(':')
//   }
var DBStore = /** @class */ (function () {
    function DBStore(dbName) {
        this.dbName = dbName;
    }
    DBStore.prototype.save = function (sess_id, obj) {
        return __awaiter(this, void 0, void 0, function () {
            var db;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, idb_1.openDB)(this.dbName, 1, {
                            upgrade: function (db) {
                                db.createObjectStore('sessions');
                            }
                        })];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.put('sessions', obj, sess_id)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DBStore.prototype.get = function (sess_id) {
        return __awaiter(this, void 0, void 0, function () {
            var db, val;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, idb_1.openDB)(this.dbName, 1, {
                            upgrade: function (db) {
                                db.createObjectStore('sessions');
                            }
                        })];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.get('sessions', sess_id)];
                    case 2:
                        val = _a.sent();
                        return [2 /*return*/, val];
                }
            });
        });
    };
    DBStore.prototype.remove = function (sess_id) {
        return __awaiter(this, void 0, void 0, function () {
            var db;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, idb_1.openDB)(this.dbName, 1, {
                            upgrade: function (db) {
                                db.createObjectStore('sessions');
                            }
                        })];
                    case 1:
                        db = _a.sent();
                        db.delete('sessions', sess_id);
                        return [2 /*return*/];
                }
            });
        });
    };
    DBStore.prototype.getList = function () {
        return __awaiter(this, void 0, void 0, function () {
            //   async function get_formatted(sess_id:string){
            //     const val = await db.get('sessions',sess_id)
            //     return {'name': val.sess.name,
            //       'time': get_date_string(val.sess.time),
            //       '_time': val.sess.time,
            //     'key': sess_id}
            //   }
            function get(sess_id) {
                return __awaiter(this, void 0, void 0, function () {
                    var val;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, db.get('sessions', sess_id)];
                            case 1:
                                val = _a.sent();
                                return [2 /*return*/, val];
                        }
                    });
                });
            }
            var db, keys, items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, idb_1.openDB)(this.dbName, 1, {
                            upgrade: function (db) {
                                db.createObjectStore('sessions');
                            }
                        })];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.getAllKeys('sessions')
                            //   async function get_formatted(sess_id:string){
                            //     const val = await db.get('sessions',sess_id)
                            //     return {'name': val.sess.name,
                            //       'time': get_date_string(val.sess.time),
                            //       '_time': val.sess.time,
                            //     'key': sess_id}
                            //   }
                        ];
                    case 2:
                        keys = _a.sent();
                        return [4 /*yield*/, Promise.all(keys.map(get))];
                    case 3:
                        items = _a.sent();
                        return [2 /*return*/, items];
                }
            });
        });
    };
    return DBStore;
}());
exports.default = DBStore;
